<!--
  Copyright 2023 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<form [formGroup]="formGroup">
  <mat-form-field class="input" appearance="fill">
    <mat-label i18n="@@app.forms.labels.jobName">Job name</mat-label>

    <input
      matInput
      placeholder="Ex. Map production areas"
      i18n-placeholder="@@app.forms.placeholders.jobName"
      [formControlName]="nameControlKey"
      [attr.maxlength]="nameMaxLength"
    />
  </mat-form-field>
</form>
